const employeeBusinessEventChange = (json: IEmployeeBusinessEventChange): IEmployeeBusinessEventChangeModel => {
	const { field, before, after } = json

	return { field, before, after }
}

export const EmployeeBusinessEvent = (json: IEmployeeBusinessEvent): IEmployeeBusinessEventModel => {
	const { id, entity_id, action, channel, date, description, editor, changes } = json

	return {
		id,
		action,
		channel,
		description,
		editor,
		entityID: entity_id,
		date: new Date(date),
		changes: changes.map(employeeBusinessEventChange),
	}
}
